var Firebase = require('firebase/app')
require('firebase/firestore')
require('firebase/database')
const config = {
  apiKey: 'AIzaSyC95quab6EMo10i7RMjEJO_RukEanB9zXo',
  authDomain: 'insure-fia-summit.firebaseapp.com',
  databaseURL: 'https://insure-fia-summit.firebaseio.com',
  projectId: 'insure-fia-summit',
  storageBucket: 'insure-fia-summit.appspot.com',
  messagingSenderId: '86160197145'
}
export const firebase = Firebase.initializeApp(config)
export const serverTimestamp = Firebase.firestore.FieldValue.serverTimestamp()
export const db = firebase.database()
export const firestore = firebase.firestore()
const settings = { timestampsInSnapshots: true }
firestore.settings(settings)
firebase.firestore().enablePersistence()



// WEBPACK FOOTER //
// ./src/firebase.config.js